import { hexToHsv, hsvToHex, hexToRgb, rgbToHex } from './colorNuancier';

/** Teintes distinctes pour les conversations (stables par id). */
export const CONVERSATION_COLOR_PALETTE = [
  '#3D9A8F',
  '#5B8FC9',
  '#6B7FD7',
  '#52A86E',
  '#9B7BB8',
  '#D4896A',
  '#4DA8B8',
  '#C97B9E',
  '#7A9E72',
  '#8B7EC8',
  '#4F9EB5',
  '#B88B5E',
] as const;

export type ConversationTheme = {
  accent: string;
  avatarBg: string;
  avatarText: string;
  bubbleIncoming: string;
  bubbleIncomingText: string;
  bubbleOutgoing: string;
  bubbleOutgoingText: string;
  listSelectedBg: string;
  listSelectedBorder: string;
};

function mixWithWhite(hex: string, whiteRatio: number): string {
  const { r, g, b } = hexToRgb(hex);
  const t = Math.min(1, Math.max(0, whiteRatio));
  return rgbToHex(r + (255 - r) * t, g + (255 - g) * t, b + (255 - b) * t);
}

function buildConversationTheme(accent: string): ConversationTheme {
  const { h, s } = hexToHsv(accent);
  const bubbleIncoming = mixWithWhite(hsvToHex(h, Math.min(s * 0.45, 28), 88), 0.12);
  const bubbleOutgoing = hsvToHex(h, Math.min(s + 8, 72), 36);
  const listSelectedBg = mixWithWhite(accent, 0.88);

  return {
    accent,
    avatarBg: hsvToHex(h, Math.min(s + 5, 65), 48),
    avatarText: '#FFFFFF',
    bubbleIncoming,
    bubbleIncomingText: hsvToHex(h, Math.min(s * 0.6, 35), 22),
    bubbleOutgoing,
    bubbleOutgoingText: '#FFFFFF',
    listSelectedBg,
    listSelectedBorder: accent,
  };
}

export function getConversationAccentColor(conversationId: number): string {
  const palette = CONVERSATION_COLOR_PALETTE;
  const index = Math.abs(conversationId) % palette.length;
  return palette[index];
}

export function getConversationTheme(conversationId: number): ConversationTheme {
  return buildConversationTheme(getConversationAccentColor(conversationId));
}

export function conversationListItemSx(theme: ConversationTheme, selected: boolean) {
  if (!selected) return undefined;
  return {
    bgcolor: theme.listSelectedBg,
    borderLeft: `3px solid ${theme.listSelectedBorder}`,
  } as const;
}
